
export default function CompanyInfo() {
  return (
    <section id="company" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">会社概要</h2>
          <p className="text-lg text-gray-600">
            地域密着で、丁寧さを第一に考えたサービスを提供しております
          </p>
        </div>

        <div className="bg-gradient-to-br from-pink-50 to-white rounded-2xl shadow-xl overflow-hidden border border-pink-100">
          <div className="grid md:grid-cols-2">
            <div className="p-10">
              <table className="w-full">
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">会社名</td>
                    <td className="py-4 text-gray-600">合同会社ヒビキ通商</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">代表者</td>
                    <td className="py-4 text-gray-600">代表社員 
菊地　和樹</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">所在地</td>
                    <td className="py-4 text-gray-600">
                      〒150-0001<br />
                      東京都渋谷区神宮前1-2-3<br />
                      ハートビル5F
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">電話番号</td>
                    <td className="py-4 text-gray-600">
                      <a href="tel:0120-000-000" className="text-green-600 hover:underline cursor-pointer">
                        0120-000-000
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">FAX</td>
                    <td className="py-4 text-gray-600">03-0000-0000</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">メール</td>
                    <td className="py-4 text-gray-600">
                      <a href="mailto:info@example.com" className="text-green-600 hover:underline cursor-pointer">
                        info@example.com
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">営業時間</td>
                    <td className="py-4 text-gray-600">8:00〜20:00（年中無休）</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">設立</td>
                    <td className="py-4 text-gray-600">2015年4月1日</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-bold text-gray-700 whitespace-nowrap">資格</td>
                    <td className="py-4 text-gray-600">
                      遺品整理士認定協会 認定<br />
                      古物商許可証 取得<br />
                      産業廃棄物収集運搬許可 取得
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bg-gradient-to-br from-green-600 to-green-700 p-10 text-white flex flex-col justify-center">
              <h3 className="text-3xl font-bold mb-6">私たちの想い</h3>
              <p className="leading-relaxed mb-6">
                遺品整理や生前整理は、単なる片付け作業ではありません。大切な方の思い出や、これからの人生を見つめ直す大切な時間です。
              </p>
              <p className="leading-relaxed mb-6">
                私たちは、お客様一人ひとりの気持ちに寄り添い、丁寧さを第一に考えたサービスを提供しております。
              </p>
              <p className="leading-relaxed mb-6">
                地域密着で培った信頼と実績を大切に、これからもお客様の心に寄り添う整理サービスを提供してまいります。
              </p>
              <div className="border-t border-green-400 pt-6 mt-6">
                <p className="font-bold text-xl">
                  「丁寧さを第一に考えた<br />地域密着サービス」
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-white rounded-xl shadow-lg p-8 border border-pink-100">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">アクセス</h3>
          <div className="aspect-video rounded-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.747389438!2d139.70273!3d35.67147!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca95bf0c0e5%3A0x2c8f4c7c0e0e0e0e!2z5p2x5Lqs6YO95riL6LC35Yy6!5e0!3m2!1sja!2sjp!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="会社所在地"
            ></iframe>
          </div>
          <p className="text-center text-gray-600 mt-4">
            <i className="ri-train-line mr-2 w-5 h-5 inline-flex items-center justify-center"></i>
            JR山手線「原宿駅」より徒歩5分 / 東京メトロ「明治神宮前駅」より徒歩3分
          </p>
        </div>
      </div>
    </section>
  );
}
